/* NO ZOOM ON INPUT FIELDS */ 
/*
(() => {
  const ua = navigator.userAgent || "";
  const isiOS =
    /iP(ad|hone|od)/.test(ua) || (ua.includes("Mac") && navigator.maxTouchPoints > 1);

  if (!isiOS) return;

  const meta = document.querySelector('meta[name="viewport"]');
  if (!meta) return;

  const original = meta.getAttribute("content") || "";

  function addMaxScaleOne(content) {
    const cleaned = content
      .replace(/,\s*maximum-scale\s*=\s*[^,]+/gi, "")
      .replace(/,\s*user-scalable\s*=\s*[^,]+/gi, "");
    const base = cleaned.trim() || "width=device-width, initial-scale=1";
    return base + ", maximum-scale=1";
  }

  function onInputTarget(t) {
    return t && t.closest && t.closest("input, textarea, select");
  }

  function lockZoom() {
    meta.setAttribute("content", addMaxScaleOne(original));
  }

  function unlockZoom() {
    meta.setAttribute("content", original);
  }

  // Run BEFORE focus happens
  ["pointerdown", "touchstart", "mousedown"].forEach((evt) => {
    document.addEventListener(evt, (e) => {
      if (onInputTarget(e.target)) lockZoom();
    }, true);
  });

  // Restore after leaving the field
  document.addEventListener("focusout", (e) => {
    if (onInputTarget(e.target)) setTimeout(unlockZoom, 0);
  }, true);
})();
*/

/* NO iOS ZOOM on small-font inputs — includes generic submit buttons */
(() => {
  const ua = navigator.userAgent || "";
  const isiOS =
    /iP(ad|hone|od)/.test(ua) || (ua.includes("Mac") && navigator.maxTouchPoints > 1);
  if (!isiOS) return;

  const meta = document.querySelector('meta[name="viewport"]');
  if (!meta) return;

  const original = meta.getAttribute("content") || "";

  const addMaxScaleOne = (content) => {
    const cleaned = content
      .replace(/,\s*maximum-scale\s*=\s*[^,]+/gi, "")
      .replace(/,\s*user-scalable\s*=\s*[^,]+/gi, "");
    const base = cleaned.trim() || "width=device-width, initial-scale=1";
    return base + ", maximum-scale=1";
  };

  const lockZoom = () => meta.setAttribute("content", addMaxScaleOne(original));
  const unlockZoom = () => meta.setAttribute("content", original);

  const isFormField = (t) => t && t.closest && t.closest("input, textarea, select");

  const isSubmitForFormWithFields = (t) => {
    if (!t || !t.closest) return false;

    const submit = t.closest('button[type="submit"], input[type="submit"], [type="submit"]');
    if (!submit) return false;

    const form = submit.form || submit.closest("form");
    if (!form) return false;

    // any “texty” fields in that form
    return !!form.querySelector(
      'input:not([type="hidden"]):not([type="submit"]):not([type="button"]):not([type="checkbox"]):not([type="radio"]), textarea, select'
    );
  };

  const shouldLock = (t) => isFormField(t) || isSubmitForFormWithFields(t);

  // BEFORE focus happens
  ["pointerdown", "touchstart", "mousedown"].forEach((evt) => {
    document.addEventListener(evt, (e) => {
      if (shouldLock(e.target)) lockZoom();
    }, true);
  });

  // any other focus path
  document.addEventListener("focusin", (e) => {
    if (isFormField(e.target)) lockZoom();
  }, true);

  document.addEventListener("focusout", (e) => {
    if (isFormField(e.target)) setTimeout(unlockZoom, 0);
  }, true);

  window.addEventListener("blur", unlockZoom);
})();





/* newsletter popup test  */ 
(() => {
  const modal = document.querySelector('[data-noah-subscribe-modal]');
  if (!modal) return;

  const input = modal.querySelector('#NoahSubscribeEmail');
  const closeBtns = modal.querySelectorAll('[data-noah-subscribe-close]');

  const setOpen = (open) => {
    modal.hidden = !open;
    modal.setAttribute('aria-hidden', open ? 'false' : 'true');
    document.documentElement.classList.toggle('noah-subscribe-open', open);
    document.body.classList.toggle('noah-subscribe-open', open);

    if (open) {
      // small delay so focus works reliably on iOS
      setTimeout(() => input && input.focus(), 50);
    } else {
      // remove hash without jumping
      if (location.hash === '#noah-subscribe') {
        history.replaceState(null, '', location.pathname + location.search);
      }
    }
  };

  const open = () => setOpen(true);
  const close = () => setOpen(false);

  // Click footer link (or any link) pointing to the hash
  document.addEventListener('click', (e) => {
    const a = e.target.closest('a[href="#noah-subscribe"], a[href="/#noah-subscribe"]');
    if (!a) return;
    e.preventDefault();
    open();
  });

  // Close actions
  closeBtns.forEach((btn) => btn.addEventListener('click', close));

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && !modal.hidden) close();
  });

  // Open if loaded with hash
  if (location.hash === '#noah-subscribe') open();

  // Open after submit if success/error happened (page reload)
  if (modal.dataset.openOnLoad === 'true') open();
})();






/* PDS PRIVATE DESIGN STUDIO FOOTER */ 
/*
(function () {
  function initFooterBarBackground() {
    const bar = document.querySelector(".o6-footer-bar");
    if (!bar) return;

    const COLORS = [
      "#ae401c",
      "#8c7f74",
      "#333333",
      "#685d5d",
      "#13c4d6",
      "#d9a300",
      "#cfaacf",
      "#004e80"
    ];

    const prefersReduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

    // Speeds (tune these)
    const CHANGE_EVERY_MS = 8000; // how often we move to a new palette pair
    const FADE_MS = 3500;         // how long the crossfade takes (smoothness)
    bar.style.setProperty("--o6-fade-ms", `${FADE_MS}ms`);

    function shuffle(arr){
      const copy = arr.slice();
      for (let i = copy.length - 1; i > 0; i--){
        const j = Math.floor(Math.random() * (i + 1));
        [copy[i], copy[j]] = [copy[j], copy[i]];
      }
      return copy;
    }

    function pickTwoDistinct(arr){
      const a = arr[Math.floor(Math.random() * arr.length)];
      let b = a, tries = 0;
      while (b === a && tries < 10){
        b = arr[Math.floor(Math.random() * arr.length)];
        tries++;
      }
      return [a, b];
    }

    function setBase(a, b){
      bar.style.setProperty("--o6-bg-a", a);
      bar.style.setProperty("--o6-bg-b", b);
    }

    function setNext(a, b){
      bar.style.setProperty("--o6-next-a", a);
      bar.style.setProperty("--o6-next-b", b);
    }

    // Initial colors (random each load)
    let deck = shuffle(COLORS);
    let idx = 0;
    const [initA, initB] = pickTwoDistinct(deck);
    setBase(initA, initB);

    if (prefersReduced) return;

    let isTransitioning = false;

    function getNextPair(){
      if (idx >= deck.length) {
        deck = shuffle(COLORS);
        idx = 0;
      }
      const a = deck[idx % deck.length];
      const b = deck[(idx + 1) % deck.length];
      idx += 2;
      return [a, b];
    }

    function transitionToNext(){
      if (isTransitioning) return;
      isTransitioning = true;

      const [nextA, nextB] = getNextPair();

      // Put the next gradient in the overlay
      setNext(nextA, nextB);

      // Trigger a smooth fade-in of the overlay
      requestAnimationFrame(() => {
        bar.classList.add("is-fading");
      });

      // After fade completes, commit next colors as the base and fade overlay away.
      setTimeout(() => {
        setBase(nextA, nextB);

        // Remove overlay (base now matches overlay, so this is visually seamless)
        bar.classList.remove("is-fading");

        isTransitioning = false;
      }, FADE_MS);
    }

    // Kick off immediately so it feels alive, then continue
    transitionToNext();
    setInterval(transitionToNext, CHANGE_EVERY_MS);
  }

  document.addEventListener("DOMContentLoaded", initFooterBarBackground);
  document.addEventListener("shopify:section:load", initFooterBarBackground);
})();
*/













/* GRADUAL LOGO BACKGROUND */
/*
(function () {
  function initLogoBackgroundColorCycleSmooth() {
    const el = document.querySelector('.header-logo__image-container[data-testid="header-logo"]');
    if (!el) return;

    const COLORS = [
      "#ae401c",
      "#8c7f74",
      "#333333",
      "#685d5d",
      "#13c4d6",
      "#d9a300",
      "#cfaacf",
      "#004e80"
    ];

    const prefersReduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

    // Quicker + fluid
    const CHANGE_EVERY_MS = 2800;  // how often it picks a new color
    const TRANSITION_MS  = 1400;  // how long the fade takes (smoothness)

    function shuffle(arr) {
      const copy = arr.slice();
      for (let i = copy.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [copy[i], copy[j]] = [copy[j], copy[i]];
      }
      return copy;
    }

    function textColorForBg(hex) {
      const h = hex.replace("#", "");
      const r = parseInt(h.slice(0, 2), 16);
      const g = parseInt(h.slice(2, 4), 16);
      const b = parseInt(h.slice(4, 6), 16);
      const lum = (0.2126 * r + 0.7152 * g + 0.0722 * b) / 255;
      return lum > 0.62 ? "#111111" : "#ffffff";
    }

    // Ensure the element can show padding/background nicely
    // (safe even if you already set this in CSS)
    el.style.display = "inline-flex";
    el.style.alignItems = "center";
    el.style.justifyContent = "center";

    let deck = shuffle(COLORS);
    let idx = 0;

    function nextColor() {
      if (idx >= deck.length) {
        deck = shuffle(COLORS);
        idx = 0;
      }
      return deck[idx++];
    }

    // Track current values so we always animate from "where we are"
    let currentBg = getComputedStyle(el).backgroundColor;
    // If it’s transparent at start, seed it with a real color
    const firstHex = nextColor();
    el.style.backgroundColor = firstHex;
    el.style.color = textColorForBg(firstHex);
    currentBg = getComputedStyle(el).backgroundColor;

    if (prefersReduced) return;

    let bgAnim = null;
    let textAnim = null;

    function animateTo(hex) {
      const nextText = textColorForBg(hex);

      // Cancel any running animations to avoid stacking
      if (bgAnim) bgAnim.cancel();
      if (textAnim) textAnim.cancel();

      const fromBg = getComputedStyle(el).backgroundColor;
      const fromText = getComputedStyle(el).color;

      // Animate background
      bgAnim = el.animate(
        [{ backgroundColor: fromBg }, { backgroundColor: hex }],
        { duration: TRANSITION_MS, easing: "ease-in-out", fill: "forwards" }
      );

      // Animate text color too (so it changes gracefully, not abruptly)
      textAnim = el.animate(
        [{ color: fromText }, { color: nextText }],
        { duration: TRANSITION_MS, easing: "ease-in-out", fill: "forwards" }
      );

      // Commit final styles so they persist cleanly after animations
      bgAnim.onfinish = () => {
        el.style.backgroundColor = hex;
        currentBg = getComputedStyle(el).backgroundColor;
      };
      textAnim.onfinish = () => {
        el.style.color = nextText;
      };
    }

    // Start cycling
    setInterval(() => {
      const c = nextColor();
      animateTo(c);
    }, CHANGE_EVERY_MS);
  }

  document.addEventListener("DOMContentLoaded", initLogoBackgroundColorCycleSmooth);
  document.addEventListener("shopify:section:load", initLogoBackgroundColorCycleSmooth);
})();
*/






/* O6 Sync Engine — footer gradient + logo solid bg (in perfect sync)
   - Uses the same logic/timing as your footer version
   - Writes vars to :root so both elements pull from the same source
   - Toggles .is-fading on BOTH elements during transitions
*/
/* JS BEFORE PASSWORD */
/*
(function () {
  function initO6SyncedColors() {
    const footer = document.querySelector(".o6-footer-bar");
    const logo   = document.querySelector('.header-logo__image-container[data-testid="header-logo"]');
    if (!footer && !logo) return;

    const COLORS = [
      "#ae401c",
      "#8c7f74",
      "#333333",
      "#685d5d",
      "#13c4d6",
      "#d9a300",
      "#cfaacf",
      "#004e80"
    ];

    const root = document.documentElement;
    const prefersReduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

    // Keep your footer "quicker" settings (edit here if you want)
    const CHANGE_EVERY_MS = 8000;
    const FADE_MS = 3500;

    // CSS reads this for both footer + logo
    root.style.setProperty("--o6-fade-ms", `${FADE_MS}ms`);
    if (footer) footer.style.setProperty("--o6-fade-ms", `${FADE_MS}ms`);

    function shuffle(arr) {
      const copy = arr.slice();
      for (let i = copy.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [copy[i], copy[j]] = [copy[j], copy[i]];
      }
      return copy;
    }

    function pickTwoDistinct(arr) {
      const a = arr[Math.floor(Math.random() * arr.length)];
      let b = a;
      let tries = 0;
      while (b === a && tries < 12) {
        b = arr[Math.floor(Math.random() * arr.length)];
        tries++;
      }
      return [a, b];
    }

    // Set vars on :root so BOTH footer + logo stay in sync
    function setBase(a, b) {
      root.style.setProperty("--o6-bg-a", a);
      root.style.setProperty("--o6-bg-b", b);
    }

    function setNext(a, b) {
      root.style.setProperty("--o6-next-a", a);
      root.style.setProperty("--o6-next-b", b);
    }

    // Random on load
    let deck = shuffle(COLORS);
    let idx = 0;

    const [initA, initB] = pickTwoDistinct(deck);
    setBase(initA, initB);

    if (prefersReduced) return;

    let isTransitioning = false;

    function getNextPair() {
      if (idx >= deck.length) {
        deck = shuffle(COLORS);
        idx = 0;
      }
      const a = deck[idx % deck.length];
      const b = deck[(idx + 1) % deck.length];
      idx += 2;
      if (a === b) return pickTwoDistinct(deck);
      return [a, b];
    }

    function addFadeClass() {
      if (footer) footer.classList.add("is-fading");
      if (logo)   logo.classList.add("is-fading");
    }

    function removeFadeClass() {
      if (footer) footer.classList.remove("is-fading");
      if (logo)   logo.classList.remove("is-fading");
    }

    function transitionToNext() {
      if (isTransitioning) return;
      isTransitioning = true;

      const [nextA, nextB] = getNextPair();

      // Put the next colors into overlay vars
      setNext(nextA, nextB);

      // Fade overlay in on BOTH elements
      requestAnimationFrame(addFadeClass);

      // After fade completes, commit next as base and fade overlay out (seamless)
      window.setTimeout(() => {
        setBase(nextA, nextB);
        removeFadeClass();
        isTransitioning = false;
      }, FADE_MS);
    }

    // Start alive
    transitionToNext();

    // Continue forever
    window.setInterval(transitionToNext, CHANGE_EVERY_MS);
  }

  document.addEventListener("DOMContentLoaded", initO6SyncedColors);
  document.addEventListener("shopify:section:load", initO6SyncedColors);
})();

*/



/* WITH PASSWORD PAGE TOO */

/* O6 Sync Engine — footer gradient + header logo solid bg + password logo solid bg (all in sync)
   - Random start on each load
   - Smooth crossfade transitions (no abrupt pops)
   - Same palette + timing for all targets
   - Writes vars to :root so any CSS can pull the same colors
   - Toggles .is-fading on all targets during transitions
*/
/*
(function () {
  function initO6SyncedColors() {
    const footer = document.querySelector(".o6-footer-bar");
    const headerLogo = document.querySelector('.header-logo__image-container[data-testid="header-logo"]');
    const passwordLogo = document.querySelector(".o6-password-logo"); // from your Password page Custom Liquid

    if (!footer && !headerLogo && !passwordLogo) return;

    const COLORS = [
      "#ae401c",
      "#8c7f74",
      "#685d5d",
      "#13c4d6",
      "#d9a300",
      "#cfaacf",
      "#004e80"
    ];

    const root = document.documentElement;
    const prefersReduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

    // ---- Timing (same as your footer version; tweak if you want faster/slower) ----
    const CHANGE_EVERY_MS = 8000; // how often we move to the next pair
    const FADE_MS = 3500;         // how long the crossfade takes

    // expose fade duration to CSS (used by ::before transitions)
    root.style.setProperty("--o6-fade-ms", `${FADE_MS}ms`);
    if (footer) footer.style.setProperty("--o6-fade-ms", `${FADE_MS}ms`);
    if (headerLogo) headerLogo.style.setProperty("--o6-fade-ms", `${FADE_MS}ms`);
    if (passwordLogo) passwordLogo.style.setProperty("--o6-fade-ms", `${FADE_MS}ms`);

    function shuffle(arr) {
      const copy = arr.slice();
      for (let i = copy.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [copy[i], copy[j]] = [copy[j], copy[i]];
      }
      return copy;
    }

    function pickTwoDistinct(arr) {
      const a = arr[Math.floor(Math.random() * arr.length)];
      let b = a;
      let tries = 0;
      while (b === a && tries < 12) {
        b = arr[Math.floor(Math.random() * arr.length)];
        tries++;
      }
      return [a, b];
    }

    // Set vars on :root so ALL components stay perfectly in sync
    function setBase(a, b) {
      root.style.setProperty("--o6-bg-a", a);
      root.style.setProperty("--o6-bg-b", b);
    }

    function setNext(a, b) {
      root.style.setProperty("--o6-next-a", a);
      root.style.setProperty("--o6-next-b", b);
    }

    // Random on load
    let deck = shuffle(COLORS);
    let idx = 0;

    const [initA, initB] = pickTwoDistinct(deck);
    setBase(initA, initB);

    if (prefersReduced) return;

    let isTransitioning = false;

    function getNextPair() {
      if (idx >= deck.length) {
        deck = shuffle(COLORS);
        idx = 0;
      }
      const a = deck[idx % deck.length];
      const b = deck[(idx + 1) % deck.length];
      idx += 2;

      // safeguard
      if (a === b) return pickTwoDistinct(deck);
      return [a, b];
    }

    function addFadeClass() {
      if (footer) footer.classList.add("is-fading");
      if (headerLogo) headerLogo.classList.add("is-fading");
      if (passwordLogo) passwordLogo.classList.add("is-fading");
    }

    function removeFadeClass() {
      if (footer) footer.classList.remove("is-fading");
      if (headerLogo) headerLogo.classList.remove("is-fading");
      if (passwordLogo) passwordLogo.classList.remove("is-fading");
    }

    function transitionToNext() {
      if (isTransitioning) return;
      isTransitioning = true;

      const [nextA, nextB] = getNextPair();

      // Put next colors into overlay vars
      setNext(nextA, nextB);

      // Fade overlay in (all targets)
      requestAnimationFrame(addFadeClass);

      // After fade completes, commit next as base and fade overlay away
      window.setTimeout(() => {
        setBase(nextA, nextB);
        removeFadeClass();
        isTransitioning = false;
      }, FADE_MS);
    }

    // Kick off quickly so it feels alive
    transitionToNext();

    // Continue forever
    window.setInterval(transitionToNext, CHANGE_EVERY_MS);
  }

  document.addEventListener("DOMContentLoaded", initO6SyncedColors);
  document.addEventListener("shopify:section:load", initO6SyncedColors);
})();
*/


/* add to cart, continue shopping buttons */
/* FREEZES SOMETIMES -- FIXING BELOW */
/*
(function () {
  function initO6SyncedColors() {
    const footer = document.querySelector(".o6-footer-bar");
    const headerLogo = document.querySelector('.header-logo__image-container[data-testid="header-logo"]');
    const passwordLogo = document.querySelector(".o6-password-logo"); // from your Password page Custom Liquid

    // If none of the core things exist, still allow cart buttons to get tagged
    // (so don't return yet)

    const COLORS = [
      "#ae401c",
      "#8c7f74",
      "#685d5d",
      "#13c4d6",
      "#d9a300",
      "#cfaacf",
      "#004e80"
    ];

    // ✅ Add selectors here (no HTML edits needed in Shopify)
    const AUTO_TAG_TARGETS = [
      { selector: ".add-to-cart-button", add: ["o6-sync-bg", "o6-pill", "o6-text-white"] },
      { selector: "a.button.cart-items__empty-button", add: ["o6-sync-bg", "o6-pill"] }
    ];

    const root = document.documentElement;
    const prefersReduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

    const CHANGE_EVERY_MS = 8000;
    const FADE_MS = 3500;

    // expose fade duration to CSS (used by ::before transitions)
    root.style.setProperty("--o6-fade-ms", `${FADE_MS}ms`);

    function tagTargets() {
      AUTO_TAG_TARGETS.forEach(rule => {
        document.querySelectorAll(rule.selector).forEach(el => {
          rule.add.forEach(cls => el.classList.add(cls));
        });
      });
    }

    function shuffle(arr) {
      const copy = arr.slice();
      for (let i = copy.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [copy[i], copy[j]] = [copy[j], copy[i]];
      }
      return copy;
    }

    function pickTwoDistinct(arr) {
      const a = arr[Math.floor(Math.random() * arr.length)];
      let b = a;
      let tries = 0;
      while (b === a && tries < 12) {
        b = arr[Math.floor(Math.random() * arr.length)];
        tries++;
      }
      return [a, b];
    }

    function setBase(a, b) {
      root.style.setProperty("--o6-bg-a", a);
      root.style.setProperty("--o6-bg-b", b);
    }

    function setNext(a, b) {
      root.style.setProperty("--o6-next-a", a);
      root.style.setProperty("--o6-next-b", b);
    }

    // Tag once immediately (so buttons get styled even before first transition)
    tagTargets();

    // If you truly have NONE of the “main” synced items, you can stop here.
    // But usually you have at least the footer.
    if (!footer && !headerLogo && !passwordLogo) {
      // Keep observing so cart buttons still get tagged when they appear
      observeDomChanges(tagTargets);
      return;
    }

    // Random on load
    let deck = shuffle(COLORS);
    let idx = 0;

    const [initA, initB] = pickTwoDistinct(deck);
    setBase(initA, initB);

    if (prefersReduced) return;

    let isTransitioning = false;

    function getNextPair() {
      if (idx >= deck.length) {
        deck = shuffle(COLORS);
        idx = 0;
      }
      const a = deck[idx % deck.length];
      const b = deck[(idx + 1) % deck.length];
      idx += 2;

      if (a === b) return pickTwoDistinct(deck);
      return [a, b];
    }

    function addFadeClass() {
      // Retag right before fades in case Shopify injected new nodes
      tagTargets();

      if (footer) footer.classList.add("is-fading");
      if (headerLogo) headerLogo.classList.add("is-fading");
      if (passwordLogo) passwordLogo.classList.add("is-fading");

      // Also fade any auto-tagged background sync elements
      document.querySelectorAll(".o6-sync-bg").forEach(el => el.classList.add("is-fading"));
    }

    function removeFadeClass() {
      if (footer) footer.classList.remove("is-fading");
      if (headerLogo) headerLogo.classList.remove("is-fading");
      if (passwordLogo) passwordLogo.classList.remove("is-fading");

      document.querySelectorAll(".o6-sync-bg").forEach(el => el.classList.remove("is-fading"));
    }

    function transitionToNext() {
      if (isTransitioning) return;
      isTransitioning = true;

      const [nextA, nextB] = getNextPair();
      setNext(nextA, nextB);

      requestAnimationFrame(addFadeClass);

      window.setTimeout(() => {
        setBase(nextA, nextB);
        removeFadeClass();
        isTransitioning = false;
      }, FADE_MS);
    }

    // Keep cart buttons tagged as Shopify updates DOM (drawer, ajax cart, etc.)
    observeDomChanges(tagTargets);

    // Kick off + loop
    transitionToNext();
    window.setInterval(transitionToNext, CHANGE_EVERY_MS);
  }

  // MutationObserver helper (so tagging survives Shopify re-renders)
  function observeDomChanges(fn) {
    // Avoid multiple observers if theme re-inits scripts
    if (window.__o6TagObserver) return;

    const obs = new MutationObserver(() => fn());
    obs.observe(document.documentElement, { childList: true, subtree: true });
    window.__o6TagObserver = obs;
  }

  document.addEventListener("DOMContentLoaded", initO6SyncedColors);
  document.addEventListener("shopify:section:load", initO6SyncedColors);
})();
*/








/* adding product title below
(function () {
  // Avoid double-running if Shopify re-inits scripts
  if (window.__o6SyncEngineV2) return;
  window.__o6SyncEngineV2 = true;

  const COLORS = [
    "#ae401c",
    "#8c7f74",
    "#685d5d",
    "#13c4d6",
    "#d9a300",
    "#cfaacf",
    "#004e80"
  ];

  // Targets you can't add classes to (Shopify) — we tag them at runtime
  const AUTO_TAG_TARGETS = [
    { selector: ".add-to-cart-button", add: ["o6-sync-bg", "o6-pill", "o6-text-white"] },
    { selector: "a.button.cart-items__empty-button", add: ["o6-sync-bg", "o6-pill"] }
  ];

  // Same timings as your footer engine
  const CHANGE_EVERY_MS = 8000; // time between transitions
  const FADE_MS = 3500;         // fade duration

  const root = document.documentElement;
  const prefersReduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  let deck = [];
  let idx = 0;

  let isTransitioning = false;
  let timerId = null;
  let observer = null;

  function shuffle(arr) {
    const copy = arr.slice();
    for (let i = copy.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [copy[i], copy[j]] = [copy[j], copy[i]];
    }
    return copy;
  }

  function pickTwoDistinct(arr) {
    const a = arr[Math.floor(Math.random() * arr.length)];
    let b = a;
    let tries = 0;
    while (b === a && tries < 12) {
      b = arr[Math.floor(Math.random() * arr.length)];
      tries++;
    }
    return [a, b];
  }

  function setBase(a, b) {
    root.style.setProperty("--o6-bg-a", a);
    root.style.setProperty("--o6-bg-b", b);
  }

  function setNext(a, b) {
    root.style.setProperty("--o6-next-a", a);
    root.style.setProperty("--o6-next-b", b);
  }

  function getVar(name) {
    return getComputedStyle(root).getPropertyValue(name).trim();
  }

  function tagTargets() {
    AUTO_TAG_TARGETS.forEach(rule => {
      document.querySelectorAll(rule.selector).forEach(el => {
        rule.add.forEach(cls => el.classList.add(cls));
      });
    });
  }

  function getFadeTargets() {
    const footer = document.querySelector(".o6-footer-bar");
    const headerLogo = document.querySelector('.header-logo__image-container[data-testid="header-logo"]');
    const passwordLogo = document.querySelector(".o6-password-logo");
    const tagged = Array.from(document.querySelectorAll(".o6-sync-bg"));

    return { footer, headerLogo, passwordLogo, tagged };
  }

  function addFadeClass() {
    const { footer, headerLogo, passwordLogo, tagged } = getFadeTargets();
    if (footer) footer.classList.add("is-fading");
    if (headerLogo) headerLogo.classList.add("is-fading");
    if (passwordLogo) passwordLogo.classList.add("is-fading");
    tagged.forEach(el => el.classList.add("is-fading"));
  }

  function removeFadeClass() {
    const { footer, headerLogo, passwordLogo, tagged } = getFadeTargets();
    if (footer) footer.classList.remove("is-fading");
    if (headerLogo) headerLogo.classList.remove("is-fading");
    if (passwordLogo) passwordLogo.classList.remove("is-fading");
    tagged.forEach(el => el.classList.remove("is-fading"));
  }

  function getNextPair() {
    if (idx >= deck.length) {
      deck = shuffle(COLORS);
      idx = 0;
    }
    const a = deck[idx % deck.length];
    const b = deck[(idx + 1) % deck.length];
    idx += 2;

    if (a === b) return pickTwoDistinct(deck);
    return [a, b];
  }

  // If we got suspended mid-transition, this snaps us back to a sane state
  function forceResync() {
    tagTargets();

    const nextA = getVar("--o6-next-a");
    const nextB = getVar("--o6-next-b");

    // If we were in the middle of a fade when the tab went inactive,
    // commit the "next" colors as base and clear fading classes.
    if (nextA && nextB) {
      setBase(nextA, nextB);
    }

    removeFadeClass();
    isTransitioning = false;
  }

  function stopLoop() {
    if (timerId) {
      clearTimeout(timerId);
      timerId = null;
    }
  }

  function scheduleNextTick(delayMs) {
    stopLoop();
    timerId = setTimeout(tick, delayMs);
  }

  function tick() {
    // If page is hidden, don't try to animate; wait until resume
    if (document.hidden) {
      scheduleNextTick(CHANGE_EVERY_MS);
      return;
    }

    if (isTransitioning) {
      // Watchdog: don't get stuck forever
      forceResync();
    }

    isTransitioning = true;

    tagTargets();

    const [nextA, nextB] = getNextPair();
    setNext(nextA, nextB);

    requestAnimationFrame(addFadeClass);

    // Finish transition
    setTimeout(() => {
      setBase(nextA, nextB);
      removeFadeClass();
      isTransitioning = false;

      scheduleNextTick(CHANGE_EVERY_MS);
    }, FADE_MS);
  }

  function start() {
    // Expose fade duration to CSS
    root.style.setProperty("--o6-fade-ms", `${FADE_MS}ms`);

    tagTargets();

    deck = shuffle(COLORS);
    idx = 0;
    const [initA, initB] = pickTwoDistinct(deck);
    setBase(initA, initB);

    if (prefersReduced) return;

    // Start alive
    forceResync();
    scheduleNextTick(0);
  }

  function observeDom() {
    if (observer) return;
    observer = new MutationObserver(() => tagTargets());
    observer.observe(document.documentElement, { childList: true, subtree: true });
  }

  // Resume handling: iOS/Safari commonly pauses timers hard in background tabs.
  function handleResume() {
    if (prefersReduced) return;
    forceResync();
    scheduleNextTick(0);
  }

  document.addEventListener("DOMContentLoaded", () => {
    start();
    observeDom();
  });

  // Shopify editor / section reloads
  document.addEventListener("shopify:section:load", () => {
    tagTargets();
    handleResume();
  });

  // Robust resume signals
  document.addEventListener("visibilitychange", () => {
    if (!document.hidden) handleResume();
  });
  window.addEventListener("focus", handleResume);
  window.addEventListener("pageshow", handleResume); // bfcache restore
})();
*/









(function () {
  if (window.__o6SyncEngineBulletproofV2) return;
  window.__o6SyncEngineBulletproofV2 = true;

  // ---- Palette ----
  const COLORS = [
    "#ae401c",
    "#8c7f74",
    "#685d5d",
    "#13c4d6",
    "#d9a300",
    "#cfaacf",
    "#004e80"
  ];

  // ---- Timing ----
  const CHANGE_EVERY_MS = 3500;
  const FADE_MS = 1500;

  const root = document.documentElement;
  const prefersReduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  // ---- Targets (NO markup edits needed) ----
  const BG_SELECTORS = [
    '.header-logo__image-container[data-testid="header-logo"]',
    '.o6-password-logo',

    /*'.add-to-cart-button',*/
   /* 'a.button.cart-items__empty-button', */
    '.cart__ctas .cart__checkout-button'
  ];

  const TEXT_SELECTORS = [
   /* '.noah-pdp-tp__title' */
  ];

  const FORCE_WHITE_TEXT_ON = [
    '.header-logo__image-container[data-testid="header-logo"]',
    '.o6-password-logo',
   /* '.add-to-cart-button',*/
    '.cart__ctas .cart__checkout-button'
  ];

  // ---- State ----
  let lastA = null;
  let lastB = null;
  let loopTimer = null;
  let isTransitioning = false;
  let domObserver = null;

  // Debounce flag for mutation observer
  let pendingInit = false;

  // ---- Helpers ----
  function randFrom(arr) {
    return arr[Math.floor(Math.random() * arr.length)];
  }

  function uniqElements(selectors) {
    const set = new Set();
    selectors.forEach(sel => {
      document.querySelectorAll(sel).forEach(el => set.add(el));
    });
    return Array.from(set);
  }

  function setVarsFadeMs() {
    root.style.setProperty("--o6-fade-ms", `${FADE_MS}ms`);
  }

  function setBaseVars(a, b) {
    root.style.setProperty("--o6-bg-a", a);
    root.style.setProperty("--o6-bg-b", b);
    lastA = a;
    lastB = b;
  }

  function setNextVars(a, b) {
    root.style.setProperty("--o6-next-a", a);
    root.style.setProperty("--o6-next-b", b);
  }

  // Pick next (A,B) with:
  // - A never repeats consecutively (prevents “looks stuck”)
  // - B != A
  // - avoids repeating exact same pair (rare)
  function pickNextPair() {
    const aPool = lastA ? COLORS.filter(c => c !== lastA) : COLORS.slice();
    const a = randFrom(aPool);

    const bPool = COLORS.filter(c => c !== a);
    let b = randFrom(bPool);

    if (lastA && lastB && a === lastA && b === lastB) {
      b = randFrom(bPool.filter(c => c !== lastB)) || b;
    }

    return [a, b];
  }

  function addFooterFadeClass() {
    const footer = document.querySelector(".o6-footer-bar");
    if (footer) footer.classList.add("is-fading");
  }

  function removeFooterFadeClass() {
    const footer = document.querySelector(".o6-footer-bar");
    if (footer) footer.classList.remove("is-fading");
  }

  // Animate a property inline (beats theme CSS)
  function animateStyle(el, prop, toValue, duration) {
    try {
      if (el.__o6Anims && el.__o6Anims[prop]) el.__o6Anims[prop].cancel();
      el.__o6Anims = el.__o6Anims || {};

      const fromValue = getComputedStyle(el)[prop];
      const anim = el.animate(
        [{ [prop]: fromValue }, { [prop]: toValue }],
        { duration, easing: "ease-in-out", fill: "forwards" }
      );

      el.__o6Anims[prop] = anim;
      anim.onfinish = () => {
        el.style[prop] = toValue;
      };
    } catch (e) {
      el.style.transition = `${prop} ${duration}ms ease-in-out`;
      el.style[prop] = toValue;
    }
  }

  // IMPORTANT CHANGE:
  // Only initialize NEW elements once, so cart drawer mutations don’t constantly reset styles.
  function initNewTargetsOnly() {
    const baseA = getComputedStyle(root).getPropertyValue("--o6-bg-a").trim() || lastA || COLORS[0];

    // BG targets
    uniqElements(BG_SELECTORS).forEach(el => {
      if (el.dataset.o6BgInit === "1") return;
      el.dataset.o6BgInit = "1";

      // set initial base color without touching future animations
      el.style.backgroundColor = baseA;
    });

    // TEXT targets
    uniqElements(TEXT_SELECTORS).forEach(el => {
      if (el.dataset.o6TextInit === "1") return;
      el.dataset.o6TextInit = "1";
      el.style.color = baseA;
    });

    // Force white text where desired (also one-time)
    uniqElements(FORCE_WHITE_TEXT_ON).forEach(el => {
      if (el.dataset.o6WhiteInit === "1") return;
      el.dataset.o6WhiteInit = "1";
      el.style.color = "#fff";
      el.style.opacity = "1";
    });
  }

  // If suspended mid-transition, commit next -> base and clean up
  function forceResync() {
    const nextA = getComputedStyle(root).getPropertyValue("--o6-next-a").trim();
    const nextB = getComputedStyle(root).getPropertyValue("--o6-next-b").trim();

    if (nextA && nextB) {
      setBaseVars(nextA, nextB);
    }

    removeFooterFadeClass();
    isTransitioning = false;

    // Only init NEW elements (don’t reset existing ones)
    initNewTargetsOnly();
  }

  function stopLoop() {
    if (loopTimer) clearTimeout(loopTimer);
    loopTimer = null;
  }

  function scheduleNext(ms) {
    stopLoop();
    loopTimer = setTimeout(tick, ms);
  }

  function tick() {
    if (document.hidden) {
      scheduleNext(CHANGE_EVERY_MS);
      return;
    }

    if (isTransitioning) {
      // watchdog recovery
      forceResync();
    }

    isTransitioning = true;

    // Make sure newly injected cart drawer buttons get initialized
    initNewTargetsOnly();

    const [a, b] = pickNextPair();

    // Footer system stays the same
    setNextVars(a, b);
    requestAnimationFrame(addFooterFadeClass);

    // Animate all BG targets (solid) to primary color A
    uniqElements(BG_SELECTORS).forEach(el => animateStyle(el, "backgroundColor", a, FADE_MS));

    // Animate all TEXT targets to primary color A
    uniqElements(TEXT_SELECTORS).forEach(el => animateStyle(el, "color", a, FADE_MS));

    // Lock text to white for the chosen ones (don’t animate these)
    uniqElements(FORCE_WHITE_TEXT_ON).forEach(el => {
      el.style.color = "#fff";
      el.style.opacity = "1";
    });

    setTimeout(() => {
      setBaseVars(a, b);
      removeFooterFadeClass();
      isTransitioning = false;
      scheduleNext(CHANGE_EVERY_MS);
    }, FADE_MS);
  }

  function start() {
    setVarsFadeMs();

    // Seed base
    const initA = randFrom(COLORS);
    const initB = randFrom(COLORS.filter(c => c !== initA));
    setBaseVars(initA, initB);
    setNextVars(initA, initB);

    // Init any currently-existing targets
    initNewTargetsOnly();

    if (prefersReduced) return;

    forceResync();
    scheduleNext(0);
  }

  function observeDom() {
    if (domObserver) return;

    domObserver = new MutationObserver(() => {
      // Debounce: cart drawer can mutate a lot; don’t thrash
      if (pendingInit) return;
      pendingInit = true;

      setTimeout(() => {
        pendingInit = false;
        // Only init NEW elements; no resetting animations
        initNewTargetsOnly();
      }, 120);
    });

    domObserver.observe(document.documentElement, { childList: true, subtree: true });
  }

  function handleResume() {
    if (prefersReduced) return;
    forceResync();
    scheduleNext(0);
  }

  document.addEventListener("DOMContentLoaded", () => {
    start();
    observeDom();
  });

  document.addEventListener("shopify:section:load", () => {
    initNewTargetsOnly();
    handleResume();
  });

  document.addEventListener("visibilitychange", () => {
    if (!document.hidden) handleResume();
  });
  window.addEventListener("focus", handleResume);
  window.addEventListener("pageshow", handleResume);
})();